import React, {useState} from "react";
import Modal from "react-responsive-modal";

import ModalReinstateChild, {ModalReinstateModes} from "root/Modals/ModalReinstateChild/ModalReinstateChild";
import {validateMode} from "root/Modals/modalFunctions";

const useModalReinstateChild = (onSaveCompleted ) =>
{
    const defaultState =  { openState: false, mode: 'none', child_id: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    const onClickActivate = ( { mode, child_id }) =>
    {
        validateMode(mode, ModalReinstateModes);

        setDialog ({ openState: true, mode: mode, child_id: child_id });
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);
    };

    const onSaveComplete = ( key, child_id ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        onSaveCompleted( key, child_id ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && <ModalReinstateChild child_id={dialog.child_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalReinstateChild ;
